<template>
    <div class="detail-seo w-100 d-inline-block mt-4">
        <div :class="{
                'input-focus-effect': true,
                'rv-valiadate-input-form': error
            }">
            <textarea :class="detail_seo != '' ? 'border-primary' : ''" id="inputOtherInfo"
                v-model="detail_seo" @focus="forcusTextArer" rows="3"></textarea>
            <label :class="{
                    'mb-0': true,
                    'input-on-alue': detail_seo != ''
                }">Nhập mô tả SEO</label>
        </div>
        <div class="text-danger fs-12px mt-1" v-if="error">{{error}}</div>
    </div>
</template>
<script>
export default {
    props: ['data', 'error'],
    data() {
        return {
            detail_seo: ''
        }
    },
    watch: {
        data(val){
            this.detail_seo = val;
        },
        detail_seo(val){
            this.$emit('update:data', val);
        }
    },
    created() {
        this.detail_seo = this.data;
    },
    methods : {
        forcusTextArer(){
            this.$emit('update:error', '');
        }
    }
}
</script>
<style lang="scss">
    .detail-seo{ 
        textarea{
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.2);
            display: block;
            width: 100%;
            border-radius: 4px;
            transition: border 0.15s linear;
            background-color: transparent;
            outline: none;
        }
    }
</style>